import { gql } from "@apollo/client"

export const GROUP_SUPERVISION_SESSIONS = gql`
  query GroupSupervisionSessions($organization_id: ID, $idTemplate: ID!) {
    groupSupervisionSessions: blocksSavedByIdTemplate(
      organization_id: $organization_id
      idTemplate: $idTemplate
      groupByIdStamp: true
    ) {
      data
    }
  }
`

export const GROUP_SUPERVISION_SESSIONS_STAFF = gql`
  query GroupSupervisionGetUser($staff_id: ID!) {
    user(staff_id: $staff_id) {
      staff_id
      staff_alias
      staff_name_first
      staff_name_last
      staff_email_address
      staff_phone_number
      staff_phone_telerecovery
    }
  }
`
